/** Checks whether the DOM is accessible in the current runtime */
export function canUseDOM() {
    return typeof window !== 'undefined' && !!window.document;
}
/** Checks whether the current runtime is a browser environment or not */
export const isBrowser = canUseDOM();
